import BackIcon from '@/icons/back-icon';
import { DateSelectedValue } from '@/utils/constant';
import { TZDate } from 'react-day-picker';
import SelectedDate from './selected-date';

const TransactionHeader = (props: {
  startDate: TZDate;
  endDate: TZDate;
  timeZone: string;
  selectedValue: DateSelectedValue;
  onBack: (path: string) => void;
  onChange: (startDate: TZDate, endDate: TZDate) => void;
}) => {
  return (
    <div className="flex h-20 w-full items-center gap-3 px-7 py-3 shadow-[0px_2px_8px_0px_#0000001A]">
      <div onClick={() => props.onBack('/gift-card')} className="flex-none">
        <BackIcon style={{ width: 60, height: 60 }} />
      </div>

      <span className="flex-none text-[2rem] text-gray-primary">
        Gift Card Transaction
      </span>
      <SelectedDate
        selectedValue={props.selectedValue}
        startDate={props.startDate}
        endDate={props.endDate}
        timeZone={props.timeZone}
        onChange={(start: TZDate, end: TZDate) => {
          props.onChange(start, end);
        }}
      />
    </div>
  );
};

export default TransactionHeader;
